import { render } from "./BillingPlan.vue?vue&type=template&id=0c05a1d4&scoped=true"
import script from "./BillingPlan.vue?vue&type=script&lang=js"
export * from "./BillingPlan.vue?vue&type=script&lang=js"

import "./BillingPlan.vue?vue&type=style&index=0&id=0c05a1d4&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c05a1d4"]])

export default __exports__